// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/update_daily_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.UpdateDailyItemRequest
 */
export class UpdateDailyItemRequest extends Message<UpdateDailyItemRequest> {
  /**
   * The ID of the daily item to Update
   *
   * @generated from field: int32 id = 1;
   */
  id = 0;

  /**
   * The name of the daily item
   *
   * @generated from field: string item_name = 2;
   */
  itemName = "";

  /**
   * The type of the daily item
   *
   * @generated from field: string item_type = 3;
   */
  itemType = "";

  constructor(data?: PartialMessage<UpdateDailyItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdateDailyItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "item_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDailyItemRequest {
    return new UpdateDailyItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDailyItemRequest {
    return new UpdateDailyItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDailyItemRequest {
    return new UpdateDailyItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDailyItemRequest | PlainMessage<UpdateDailyItemRequest> | undefined, b: UpdateDailyItemRequest | PlainMessage<UpdateDailyItemRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDailyItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UpdateDailyItemResponse
 */
export class UpdateDailyItemResponse extends Message<UpdateDailyItemResponse> {
  constructor(data?: PartialMessage<UpdateDailyItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdateDailyItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDailyItemResponse {
    return new UpdateDailyItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDailyItemResponse {
    return new UpdateDailyItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDailyItemResponse {
    return new UpdateDailyItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDailyItemResponse | PlainMessage<UpdateDailyItemResponse> | undefined, b: UpdateDailyItemResponse | PlainMessage<UpdateDailyItemResponse> | undefined): boolean {
    return proto3.util.equals(UpdateDailyItemResponse, a, b);
  }
}

